import angular from 'angular';
import _ from 'lodash';

const storeModule =  function DashboardStoreFactory($log, $rootScope, Dispatcher, StoreStates) {
    'ngInject';
    let storeStates = {
      'dashboard': {},
      'chart': {}
    };
    let dashboardData = {
      'dashboard': {},
      'chart': {}
    };

    const notifyChange = function() {
      $rootScope.$broadcast('DASHBOARD_UPDATE');
    };

    const notifyFail = function() {
      $rootScope.$broadcast('DASHBOARD_FAIL');
    };

    const notifyChartChange = function() {
      $rootScope.$broadcast('DASHBOARDCHART_UPDATE');
    };

    const notifyChartFail = function() {
      $rootScope.$broadcast('DASHBOARDCHART_FAIL');
    };

    const cleanStore = function() {
      storeStates = {
        'dashboard': {},
        'chart': {}
      };
      dashboardData = {
        'dashboard': {},
        'chart': {}
      };
    };

    Dispatcher.register(function(action) {
      switch (action.actionType) {
        case 'DASHBOARD_LOAD':
          storeStates.dashboard[action.data.days] = action.state;
          dashboardData.dashboard[action.data.days] = action.data.dashboardData;
          notifyChange();
          break;
        case 'DASHBOARD_LOAD_START':
          storeStates.dashboard[action.data.days] = action.state;
          break;
        case 'DASHBOARD_LOAD_FAIL':
          storeStates.dashboard[action.data.days] = action.state;
          notifyFail();
          break;
        case 'DASHBOARDCHART_LOAD_START':
          storeStates.chart[action.data.days] = action.state;
          break;
        case 'DASHBOARDCHART_LOAD_FAIL':
          storeStates.chart[action.data.days] = action.state;
          notifyChartFail();
          break;
        case 'DASHBOARDCHART_LOAD':
          storeStates.chart[action.data.days] = action.state;
          dashboardData.chart[action.data.days] = _.map(action.data.chartData, (chartValue) => {
            chartValue.balanceValue = parseFloat((chartValue.balanceValue / 100).toFixed(2));
            return chartValue;
          });
          notifyChartChange();
          break;
        case 'GLOBAL_CLEAN':
          cleanStore();
          break;
      }
    });

    const storeObject = {
      getDashboardStoreState: function(days) {
        if (days in storeStates.dashboard) {
          return storeStates.dashboard[days];
        } else {
          return StoreStates.STORE_EMPTY;
        }
      },
      getDashboardData: function(days) {
        return dashboardData.dashboard[days];
      },
      getChartStoreState: function(days) {
        if (days in storeStates.chart) {
          return storeStates.chart[days];
        } else {
          return StoreStates.STORE_EMPTY;
        }
      },
      getChartData: function(days) {
        return dashboardData.chart[days];
      },
      forceExpired: cleanStore
    };

    return storeObject;
  }

export default storeModule;



/** WEBPACK FOOTER **
 ** ./client/app/common/services/tinaba-framework/dashboardStore.factory.js
 **/